import {
    Button,
    FormControl,
    Grid,
    Paper,
    TextField,
    Typography,
    CircularProgress,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { gruppentyp } from '../../../utils/apiTypes';
import { validateHelper, validate } from '../../../features/validate/validate';
import {
    selectSelectedGruppe,
    updateGruppe,
    createGruppe,
    selectGruppentypen,
    selectGruppeLoading,
    setNewMode,
    setEditMode,
    selectNewMode,
    selectEditMode,
    setSelectedGruppe,
    setError,
    resetError,
} from './gruppenverwaltungSlice';
import { useStyles } from './gruppenverwaltungStyles';

export const GruppenverwaltungEdit: React.FC = () => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const selectedGruppe = useAppSelector(selectSelectedGruppe);
    const gruppentypen = useAppSelector(selectGruppentypen);
    const gruppenLoading = useAppSelector(selectGruppeLoading);
    const newMode = useAppSelector(selectNewMode);
    const editMode = useAppSelector(selectEditMode);

    const [gruppeSelectNameInputValue, setGruppeSelectNameInputValue] = React.useState(editMode ? selectedGruppe.name : "");
    const [gruppeSelectTypInputValue, setGruppeSelectTypInputValue] = React.useState(editMode ? gruppentypen.find(x => x.id == selectedGruppe.typ)?.name : "");
    const [gruppentypSelect, setGruppentypSelect] = React.useState<gruppentyp | null>(editMode ? gruppentypen.find(x => x.id == selectedGruppe.typ) || null : null);

    const gruppenNameAendern = () => {
        dispatch(setEditMode(false));
        dispatch(setSelectedGruppe(selectedGruppe));
        dispatch(updateGruppe(selectedGruppe, gruppeSelectNameInputValue, gruppentypSelect ? gruppentypSelect?.id : 0));
    }

    const neueGruppeErstellen = () => {
        dispatch(setNewMode(false));
        dispatch(createGruppe(gruppeSelectNameInputValue, gruppentypSelect ? gruppentypSelect?.id : 0));
    }

    return (
        <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
            <form className={classes.root} noValidate autoComplete="off" style={{ marginBottom: "10px" }}>
                <div>
                    <Grid container spacing={2} style={{ marginBottom: "10px" }} >
                        <Grid item md={6} style={{ paddingLeft: "16px" }}>
                            <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"} style={{ marginLeft: "8px" }} >
                                {newMode ? "Neue Gruppe erstellen" : "Gruppe ändern"}
                            </Typography>
                        </Grid>
                        <Grid item md={3} />
                        <Grid item md={3} style={{ paddingRight: "24px" }}>
                            <Grid container item md={12} style={{ alignItems: "center" }} >
                                <Grid item md={6} style={{ paddingRight: "10px" }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            newMode ? dispatch(setNewMode(false)) : dispatch(setEditMode(false))
                                        }}
                                        color="secondary"
                                        className={classes.showButton}
                                        style={{ width: "100%" }}
                                    >
                                        Abbrechen
                                    </Button>
                                </Grid>
                                <Grid item md={6}>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        onClick={() => {
                                            newMode ? neueGruppeErstellen() : gruppenNameAendern()
                                        }}
                                        className={classes.showButton}
                                        disabled={validate(dispatch, setError, resetError, gruppeSelectNameInputValue, "name") || gruppeSelectNameInputValue == null && gruppeSelectTypInputValue == null}
                                        style={{ minHeight: "36px", width: "100%" }}>
                                        {gruppenLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                        <Grid container item md={12} style={{ alignItems: "center" }}>
                            <Grid item md={6} style={{ paddingLeft: "16px", paddingRight: "8px" }}>
                                <TextField
                                    required={true}
                                    label="Gruppenname"
                                    variant="outlined"
                                    value={gruppeSelectNameInputValue}
                                    error={validate(dispatch, setError, resetError, gruppeSelectNameInputValue, "name")}
                                    helperText={validateHelper(gruppeSelectNameInputValue)}
                                    onChange={(event) => {
                                        setGruppeSelectNameInputValue(event.target.value)
                                    }}
                                    style={{ width: "100%" }} />

                            </Grid>
                            <Grid item md={6} style={{ paddingRight: "24px" }}>
                                <FormControl className={[classes.formControl, classes.fullWidth].join(' ')} style={{ paddingRight: "0px" }}>
                                    <Autocomplete
                                        id="select-gruppentyp"
                                        value={gruppentypSelect}
                                        noOptionsText={<React.Fragment>
                                            {gruppenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Gruppentypen"}</React.Fragment>}
                                        onChange={(event, newValue) => {
                                            setGruppentypSelect(newValue);
                                        }}
                                        inputValue={gruppeSelectTypInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setGruppeSelectTypInputValue(newInputValue);
                                        }}
                                        options={gruppentypen}
                                        getOptionLabel={(option) => (option ? option.name : "")}
                                        renderInput={(params) => (
                                            <TextField
                                                required={true}
                                                {...params}
                                                label="Gruppentyp"
                                                variant="outlined"
                                            />
                                        )}
                                        style={{ width: "100%" }}

                                    />
                                </FormControl>
                            </Grid>

                        </Grid>
                    </Grid>
                </div>
            </form>
        </Paper>
    );
}